import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

const listItemSelector = ".basic-list-item, .items-grid .row > div, .menu-item"

class ListView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const list = [...container.querySelectorAll(listItemSelector)]
    TweenMax.killTweensOf(container)
    TweenMax.killTweensOf(list)
    TweenMax.set(list, {opacity: 1})
    TweenMax.set(container, {opacity: 1})
    // console.log(list)
    const t = new TimelineMax({repeat: 0})
    t.from(container, .15, {opacity: 0})
    t.from(list, .35, {opacity: 0, y: 5, delay: (ind) => (ind * .05 > 1 ? 1 : ind * .05) + .1, ease: Power2.easeOut}, 0)
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const list = [...container.querySelectorAll(listItemSelector)]
    TweenMax.killTweensOf(container)
    TweenMax.killTweensOf(list)
    const t = new TimelineMax({repeat: 0})
    t.to(list, .35, {opacity: 0, y: 0, delay: (ind) => ind * .03 > 1 ? 1 : ind * .03, ease: Power2.easeIn})
    t.to(container, .1, {opacity: 0}, .4)
    
  }

}

export default ListView